<template>
    <!--  Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <GameLogViewOne :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>
     <!--  Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <GameLogViewTwo :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>

    <!--  Theme three -->
    <div v-if="themeStore.themeIndex === 3">
        <GameLogViewThree :data-set="dataSet" @get-next-page-msg-list="getNextPageMsgList" @on-click-tab="onClickTab" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { getBetDetails } from '@/api/game';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import GameLogViewOne from '@/themes/themeOne/gameLog/gameLogView.vue';
import GameLogViewTwo from '@/themes/themeTwo/gameLog/gameLogView.vue';
import GameLogViewThree from '@/themes/themeThree/gameLog/gameLogView.vue';
import { BetRecord, GameLogData, PAGE_SIZE, TAB_LIST } from './supportScript';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')

const active = ref(0);
const total = ref(0)
const pageSize = ref(PAGE_SIZE)
const pageNum = ref(1)
const tabList = ref(TAB_LIST)
const betList = ref<BetRecord[]>([])
const betTotal = ref(0)
const winLossAmount = ref(0)

const dataSet = computed<GameLogData>(() => ({
    active: active.value,
    total: total.value,
    pageSize: pageSize.value,
    pageNum: pageNum.value,
    tabList: tabList.value,
    betList: betList.value,
    betTotal: betTotal.value,
    winLossAmount: winLossAmount.value,
}))

const activeTimeGap = computed(() => tabList.value[active.value].time)

const onClickTab = (data: any) => {
    active.value = data.name
    total.value = 0
    pageNum.value = 1
    betList.value = []
    loadingRef.value.open()
    getGameLogDetails()
}
const getNextPageMsgList = () => {
    loadingRef.value.open()
    if (total.value > pageSize.value * pageNum.value) {
        pageNum.value = pageNum.value + 1
        getGameLogDetails()
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getGameLogDetails = () => {
    let data = {
        pageSize: pageSize.value,
        pageNum: pageNum.value,
        timeGap: activeTimeGap.value
    }
    getBetDetails(data).then(res => {
        loadingRef.value.close()
        total.value = res.data?.totalRecords
        betList.value = [...betList.value, ...res.data?.gameDetailList]
        betTotal.value = res.data?.betTotal
        winLossAmount.value = res.data?.totalResult
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

onMounted(() => {
    loadingRef.value.open()
    getGameLogDetails()
})
</script>